import { Link } from "react-router-dom";

import { Button, Grid, Paper, Text, Title } from "@mantine/core";
import { FaArrowRight } from "react-icons/fa";
import { FormSuccessProps } from "types/module/User/Onboarding";

const FormSuccess: React.FC<FormSuccessProps> = ({ title, description, restartSteps }) => {
  return (
    <>
      <Title ta="center" c="black">
        {title}
      </Title>
      <Paper withBorder shadow="md" p={30} mt={20} radius="md">
        <Grid>
          <Grid.Col>
            <Text component="div" ta="center" size="lg">
              <b>{description}</b>
            </Text>
          </Grid.Col>
          <Grid.Col span={{ md: 8 }}>
            <Button rightSection={<FaArrowRight size={14} />} onClick={restartSteps} fullWidth>
              Enroll another user
            </Button>
          </Grid.Col>
          <Grid.Col span={{ md: 4 }}>
            <Link to="/user">
              <Button variant="default" fullWidth>
                Finish
              </Button>
            </Link>
          </Grid.Col>
        </Grid>
      </Paper>
    </>
  );
};

export default FormSuccess;
